// Category ids for the top level categories on square
export const ParentCategoryIds =  {
    Products: 'HUMYRU6WAPVQ54PYRR4FEUAZ',
    Services: 'CN52KUXKDQIPZ673W7AQ6ZP2'
}